import { Component, input, output } from '@angular/core';

import { CbAlertBannerModule } from '@chubb/ui-components';
import { BannerAlertType } from '../../../shared/enums/alert-icon.enum';
import { WidgetsModule } from '../widgets.module';

@Component({
  selector: 'app-alert-banner',
  imports: [WidgetsModule, CbAlertBannerModule],
  templateUrl: './alert-banner.component.html',
  styleUrl: './alert-banner.component.scss',
})
export class AlertBannerComponent {
  showAlertBanner = input<boolean>(false);
  message = input.required<string>();
  alertType = input.required<BannerAlertType>();
  closeTriggered = output<void>();

  hideAlert() {
    this.closeTriggered.emit();
  }
}
